import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视分类",
    links: [
      { to: "/category/movie", label: "电影" },
      { to: "/category/tv", label: "电视剧" },
      { to: "/category/scifi", label: "科幻片" },
      { to: "/category/romance", label: "爱情片" },
    ],
  },
  {
    title: "热门频道",
    links: [
      { to: "/category/action", label: "动作片" },
      { to: "/category/suspense", label: "悬疑片" },
      { to: "/category/china", label: "国产剧集" },
      { to: "/category/hollywood", label: "欧美影视" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/about#contact", label: "联系方式" },
      { to: "/about#copyright", label: "版权说明" },
      { to: "/search", label: "搜索影视" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-clapperboard-fill text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">天龙影院</span>
            </div>
            <p className="text-sm font-body leading-relaxed text-background-300 max-w-xs">
              天龙影院是一个专注高清影视内容的在线浏览平台，汇聚最新电影与热播剧集，多维度分类检索，助你快速发现想看的好作品。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm font-body text-background-300 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-body text-background-400 text-center sm:text-left">
            © 2026 天龙影院 · 本站影视资料及图片均为演示内容，仅供界面展示，不提供真实播放服务。
          </p>
          <div className="flex items-center gap-4 text-background-400">
            <span className="flex items-center gap-1.5 text-xs font-body">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              support@tianlong-cinema.demo
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}